module.exports = __webpack_public_path__ + "img/text-height.a549b97b.svg";